module.exports = __webpack_public_path__ + "static/media/Milex-Shaatz-Pessary-Instructions-for-Use.30f1b72e.jpg";